/************  GESTION DE LA NAVIGATION *****************/
  
  $("document").ready(setupNav);
  let initMenuSize = 0;
  
  function setupNav() {
    initBurgerMenu();
    reduceDesktopMenu();
    initMobileMenu();
    $(".navigation .menu .has-submenu .top-item").click(showSubMenu);
    $(".navigation .menu .btn-back").click(hideSubMenu);
    desktopMenuSearch();
  }
  
  // Gestion du burger menu en responsive
  function initBurgerMenu() {
    $(window).resize(function () {
      if ($(window).width() >= 1200 && $(".navigation-menu").hasClass("open")) {
        $(".navigation-menu").removeClass("open");
      }
      
      setTimeout(function () {
        $(".navigation-menu .menu").removeAttr('style');
        initMenuSize = $(".navigation-menu .menu").innerHeight() + 5;
        $(".navigation-menu .menu").css("height", initMenuSize + "px");
        $('.navigation-menu .scrollcontainer').css("height", initMenuSize + "px");
      }, 500);
    });
  
    $(".burger").click(function () {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(".navigation-menu").removeClass("open");
        $("html, body").removeAttr("style");
        $(this).attr("aria-label", "Ouvrir le menu de navigation");
      } else {
        $(this).addClass("active");
        $(".navigation-menu").addClass("open");
        $(this).attr("aria-label", "Fermer le menu de navigation");
        if ($(window).width() < 1200) $("html, body").css("overflow", "hidden");
  
        //attrape tout les elements focusable de la nav
        let focusableElements = $(".navigation").find(
          'button, a, input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        focusableElements.first().focus();
  
        document.onkeydown = function (evt) {
          if ($(".burger").hasClass("active")) {
            let keyCode = evt.keyCode || evt.which;
  
            //focus first element une fois que l'on était sur le dernier
            if (keyCode === 9) {
              if (focusableElements.last().is(":focus")) {
                focusableElements.first().focus();
              }
            }
          }
        };
      }
    });
  }
  
  function reduceDesktopMenu() {
    $(window).scroll(function () {
      if ($(this).scrollTop() >= 85) {
        // $('header').css('paddingTop', 85);
        $(".navigation").addClass("fixed");
      } else {
        // $('header').css('paddingTop', '0');
        $(".navigation").removeClass("fixed");
      }
    });
  }
  
  function initMobileMenu() {
    if ($(window).width() < 1200 && initMenuSize === 0) {
      $(".menu-item-has-children .top-item").click(function () {
        $(this).parent().children(".btn-arrow").click();
      });
      setTimeout(function () {
        initMenuSize = $(".navigation-menu .menu").innerHeight() + 5;
        $(".navigation-menu .menu").css("height", initMenuSize + "px");
        $('.navigation-menu .scrollcontainer').css("height", initMenuSize + "px");
      }, 500);
    }
  }
  
  // Fonction qui permet d'afficher un sous menu en mobile
  function showSubMenu(e) {
    if ($(".navigation-menu").hasClass("open")) {
      e.preventDefault();
    }
    $(this).parent().parent().children(".sub-menu").fadeIn(400);
    $(this).parent().parent().children(".sub-menu").addClass("show");
    if ($(".navigation-menu .menu").hasClass("showLevel1")) {
      $(".navigation-menu .menu").addClass("showLevel2");
    } else {
      $(".navigation-menu .menu").addClass("showLevel1");
    }
    $('.navigation-menu .menu').css('height', $(this).parent().parent().children('.sub-menu').innerHeight() + 'px');
    $('.navigation-menu .scrollcontainer').css('height', $(this).parent().parent().children('.sub-menu').innerHeight() + 5 + 'px');
    $('.navigation-menu .menucontainer').scrollTop(0);
  }
  
  // Fonction qui permet de cacher un sous menu en mobile
  function hideSubMenu() {
    $(this).parent().parent().fadeOut(400);
    $(this).parent().parent().removeClass("show");
    if ($(".navigation-menu .menu").hasClass("showLevel2")) {
      $(".navigation-menu .menu").removeClass("showLevel2");
      $('.navigation-menu .menu').css('height', $('.menu .sub-menu.show').innerHeight() + 'px');
      $('.navigation-menu .scrollcontainer').css('height', $('.menu .sub-menu.show').innerHeight() + 5 + 'px');
    } else {
      $(".navigation-menu .menu").removeClass("showLevel1");
      $(".navigation-menu .menu").css("height", initMenuSize + "px");
      $('.navigation-menu .scrollcontainer').css("height", initMenuSize + "px");
    }
    $('.navigation-menu .menucontainer').scrollTop(0);
  }
  
  function desktopMenuSearch() {
    if ($(window).width() >= 1200) {
      $(".tools .searchlogo").click(function (e) {
        e.preventDefault();
        if (!$(".search-bar").hasClass("search-active")) {
          $(".search-bar").addClass("search-active");
          $(".search-input").slideDown(300);
        } else {
          $(".search-bar").removeClass("search-active");
          $(".search-input").slideUp(300);
        }
      });
    }
  }
